import React from 'react';

const Footer: React.FC = () => {
  return <footer>Newsapp {new Date().getFullYear()} &copy; </footer>;
};
export default Footer;
